import GetLocationByIdRequestModelBase from '../_generated/modelBases/get-location-by-id-request-model-base';

export default class GetLocationByIdRequestModel extends GetLocationByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
